export default __webpack_public_path__ + "static/media/eduOrange.0793a40d.svg";